/* eslint-disable */
import Vue from "vue";
import Vuex from "vuex";
import authStore from "./modules/authStore";
import corporation from "./modules/corporation";
import contract from "./modules/contract";
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState({
    storage: window.sessionStorage,
  })],
  state: {},
  mutations: {},
  actions: {},
  modules: {
    authStore,
    corporation,
    contract
  }
});


// WEBPACK FOOTER //
// ./src/store/index.js